import { FormControl, InputLabel, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { StatAlertsStatus } from 'app/enum/stat-alerts';

interface GridChannelEditProps {
    /**
     * Default: channel
     */
    name?: string;
    label?: string;
    value?: StatAlertsStatus;
    autofocus?: boolean;
    onChange?: SelectProps['onChange'];
    emptyLabel?: React.ReactNode;
}

export class StatAlertsStatusSelector extends React.Component<GridChannelEditProps> {
    public render(): React.ReactNode {
        return (
            <FormControl fullWidth>
                {this.props.label ? <InputLabel>{this.props.label}</InputLabel> : ''}
                <Select
                    name={this.props.name || 'status'}
                    ref={(element) => {
                        if (this.props.autofocus && element instanceof HTMLElement) {
                            element.querySelector<HTMLSelectElement>('div.MuiSelect-select')!.focus();
                        }
                    }}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    displayEmpty={undefined === this.props.label}
                    label={this.props.label}
                >
                    <MenuItem value={StatAlertsStatus.OPEN}>Open</MenuItem>
                    <MenuItem value={StatAlertsStatus.INPROCESS}>In Process</MenuItem>
                    <MenuItem value={StatAlertsStatus.COMPLETED}>Completed</MenuItem>
                    <MenuItem value={StatAlertsStatus.CANCELLED}>Cancelled</MenuItem>
                    <MenuItem value={StatAlertsStatus.DUPLICATE}>Duplicate</MenuItem>
                </Select>
            </FormControl>
        );
    }
}
